import styled, { keyframes } from "styled-components";

const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const AppFlexBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(-45deg, #0f0c29, #1a1a3e, #16213e, #0d1b2a);
  background-size: 400% 400%;
  animation: ${gradientShift} 12s ease infinite;
  padding: 24px;
`;
